import React from 'react';
import ImageUploadField from '../../components/ImageUploadField';

export default function PromotionNameImageForm({
  name,
  onNameChange,
  imageUrl,
  onImageUrlChange,
  onImageUploadLoadingChange,
  isImageUploading = false,
}) {
  return (
    <>
      <section className="shop-create-section">
        <label className="shop-create-label" htmlFor="promotion-name">
          Название акции <b style={{ color: 'red' }}>*</b>
        </label>
        <input
          id="promotion-name"
          className="shop-create-input"
          placeholder="например, Скидка на кофе"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          autoComplete="off"
        />
      </section>

      {isImageUploading ? <ImageUploadField
        label="Изображение акции"
        help="Выберите изображение — ссылка подставится автоматически"
        value={imageUrl}
        onChange={onImageUrlChange}
        onUploadLoadingChange={onImageUploadLoadingChange}
        defaultUrl=""
      /> : ""}
    </>
  );
}
